import { useState, useEffect } from "react";
import { useParams, useHistory } from "react-router-dom";
import { db } from "../FIREBASE/firebase";
import { TripDetailView } from "../VIEW/TripDetailView";
import routeUrls from "../COMPONENTS/navbar/navLink";

function TripDetailPage() {
  const { id } = useParams<{ id: string }>();
  const [trip, setTrip] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const history = useHistory();

  useEffect(() => {
    db.collection("trips").doc(id).get().then((snap) => {
      if (!snap.exists) {
        history.push(routeUrls.BLOGG);
      } else {
        setTrip(snap.data());
      }
      setLoading(false);
    });
  }, [id]);

  if (loading) return null;
  return <TripDetailView trip={trip} />;
}

export default TripDetailPage;
